const TRAININGS_ROUTES = {
  path: 'trainings',
  component: () => import('@/pages/Trainings/TrainingsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'trainings.index',
      component: () => import('@/pages/Trainings/TrainingsPage.vue'),
    },
    {
      path: 'create',
      name: 'trainings.create',
      component: () => import('@/pages/Trainings/TrainingsFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'trainings.edit',
      component: () => import('@/pages/Trainings/TrainingsFormPage.vue'),
    },
    {
      path: ':trainingId/questions',
      name: 'trainings.questions.index',
      component: () =>
        import('@/pages/Trainings/Questions/TrainingQuestionsPage.vue'),
    },
    {
      path: ':trainingId/questions/create',
      name: 'trainings.questions.create',
      component: () =>
        import('@/pages/Trainings/Questions/TrainingQuestionsFormPage.vue'),
    },
    {
      path: ':trainingId/questions/:id/edit',
      name: 'trainings.questions.edit',
      component: () =>
        import('@/pages/Trainings/Questions/TrainingQuestionsFormPage.vue'),
    },
  ],
};

export default TRAININGS_ROUTES;
